import React from 'react';
import { RESTORATION_ZONE_LABELS, RESTORATION_ZOOM_LABEL, RESTORATION_TOTAL_STEPS } from '../../utils/restoration';
import './game.css';

export default function RestorationHud({ visitedZones, zoomed, presenceCount, restoredCount }) {
  const progress = visitedZones.size + (zoomed ? 1 : 0);
  const steps = [...RESTORATION_ZONE_LABELS, RESTORATION_ZOOM_LABEL];

  return (
    <div className="restoration-hud">
      <div className="restoration-hud-header">
        <i className="bi bi-magic" /> Restaurando la escultura
        <span className="restoration-hud-count">{progress}/{RESTORATION_TOTAL_STEPS}</span>
      </div>
      <p className="restoration-hud-hint">Girá y acercate al modelo para restaurarlo por completo.</p>
      <div className="restoration-steps">
        {steps.map((label, idx) => {
          const done = idx < RESTORATION_ZONE_LABELS.length ? visitedZones.has(idx) : zoomed;
          return (
            <span key={label} className={`restoration-step ${done ? 'done' : ''}`}>
              <i className={`bi ${done ? 'bi-check-circle-fill' : 'bi-circle'}`} /> {label}
            </span>
          );
        })}
      </div>
      <div className="restoration-progress-bar">
        <div className="restoration-progress-fill" style={{ width: `${(progress / RESTORATION_TOTAL_STEPS) * 100}%` }} />
      </div>

      {(presenceCount > 1 || restoredCount > 0) && (
        <div className="restoration-social-row">
          {presenceCount > 1 && (
            <span className="restoration-presence">
              <i className="bi bi-people-fill" /> {presenceCount} exploradores acá ahora
            </span>
          )}
          {restoredCount > 0 && (
            <span className="restoration-community">
              <i className="bi bi-trophy-fill" /> Restaurada {restoredCount} {restoredCount === 1 ? 'vez' : 'veces'} por la comunidad
            </span>
          )}
        </div>
      )}
    </div>
  );
}
